import {
    styleChanged
} from "./styleActions";

export
const handlingChange = (e, component) => {
    const value = e.target.value;
    const property = e.target.name;
    window.store.dispatch(styleChanged(value, property, component));
};